export default function getAdPrice(ad: any): number {
  return Number(ad.price_object_eur ? ad.price_object_eur : 0);
}
